import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { NoDataToDisplayComponent } from '@connect-services/client/components/no-data-to-display/no-data-to-display.component';
import {
    ProjectDepositsSettingsService,
    TableData,
} from '@connect-services/client/services/project-deposits-settings.service';
import { PaginatorComponent } from '@connect-services/src/lib/components/paginator/paginator.component';
import { CustomTableComponent } from '@connect-services/src/lib/components/table/table.component';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CustomTableComponent, NoDataToDisplayComponent, PaginatorComponent, RessourcesModule],
    selector: 'app-project-deposit-section',
    templateUrl: 'project-deposit-section.component.html',
})
export class ProjectDepositSectionComponent {
    public readonly dataSection = input.required<TableData>();

    protected readonly projectDepositsSettingsService = inject(ProjectDepositsSettingsService);
}
